import axios, { AxiosPromise } from 'axios';

import { IMasterDataSyncData } from '../../../@types/model/masterData/sync/MasterDataSyncData';

export default class MasterDataSyncHttpService {
    public static getAllMasterData(lastUpdateUnix ?: number) : AxiosPromise<IMasterDataSyncData> {
        return axios.get(`${API_URL}/v1/Data/Web`, {
            params: {
                lastUpdateUnix,
            },
        });
    }
}
